export enum UserRole {
	RecruitmentConsultant = "Recruitment Consultant",
	Compliance = "Compliance",
	SuperAdministrator = "Super Administrator",
	Manager = "Manager",
}
